module.exports = __webpack_public_path__ + "static/img/eh.ea931ccc.svg";